import useSWR from 'swr';

import { useGraphServerInfo } from '../api/useGraphSwr';

const PYPI_URL = 'https://pypi.org/pypi/langgraph-api/json';
const NPM_URL = 'https://registry.npmjs.org/@langchain/langgraph-api';

interface PyPIPackageInfo {
  info: {
    version: string;
    upload_time: string;
  };
  releases: Record<string, any>;
}

interface NPMPackageInfo {
  'dist-tags': {
    latest: string;
  };
  time: Record<string, string>;
}

const pypiGetter = async (): Promise<string | undefined> => {
  const response = await fetch(PYPI_URL);
  if (!response.ok) {
    throw new Error(
      `Failed to fetch PyPI package info: ${response.statusText}`
    );
  }
  const data: PyPIPackageInfo = await response.json();
  return data.info.version;
};

const npmFetcher = async (): Promise<string | undefined> => {
  const response = await fetch(NPM_URL);
  if (!response.ok) {
    throw new Error(`Failed to fetch NPM package info: ${response.statusText}`);
  }
  const data: NPMPackageInfo = await response.json();
  return data['dist-tags'].latest;
};

export const useLanggraphApiVersion = () => {
  const { data: graphServerInfo } = useGraphServerInfo();
  const { context } = graphServerInfo ?? {};
  const isJs = context === 'js';
  return useSWR<string | undefined>(
    ['langgraph-api-version', isJs],
    isJs ? npmFetcher : pypiGetter,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }
  );
};
